export type DuplicateField =
    | 'firstName'
    | 'lastName'
    | 'birthDate'
    | 'asylumNumber'
    | 'zemisNumber'
    | 'address';

export function getDuplicateFieldLabel(field: DuplicateField) {
    switch (field) {
        case 'firstName':
            return 'Vorname';
        case 'lastName':
            return 'Nachname';
        case 'birthDate':
            return 'Geburtsdatum';
        case 'asylumNumber':
            return 'N-Nummer';
        case 'zemisNumber':
            return 'ZEMIS-Nummer';
        case 'address':
            return 'Adresse';
    }
}

export function getDuplicateFieldArticle(field: DuplicateField) {
    switch (field) {
        case 'firstName':
        case 'lastName':
            return 'Dieser';
        case 'birthDate':
            return 'Dieses';
        case 'asylumNumber':
        case 'zemisNumber':
        case 'address':
            return 'Diese';
    }
}